import { render, staticRenderFns } from "./FormularioCasasCobranza.vue?vue&type=template&id=60f1c8d4&"
import script from "./FormularioCasasCobranza.vue?vue&type=script&lang=js&"
export * from "./FormularioCasasCobranza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports